import { ReactElement } from "react";
import { HammerIcon } from "lucide-react";

import {
  SheetCollapsibleIndustryOrSkillList,
  SheetSectionContainer,
  SheetSectionEmptyText,
  SheetSectionHeader,
} from "@/components";

import { Skill } from "@/types";

export const SheetSkills = ({
  showResumeSkills,
  skills,
}: {
  showResumeSkills?: boolean;
  skills: Skill[];
}) => {
  // Filter out skills without names.
  let filteredSkills = skills.filter((skill) => skill.name?.trim());

  // Filter out skills that are not on the user's profile if applicable.
  filteredSkills = showResumeSkills
    ? filteredSkills
    : filteredSkills.filter((skill) => !skill.isResumeField);

  const SkillsSheetSectionContainerAndHeader = ({
    children,
    isEmpty,
  }: {
    children: ReactElement;
    isEmpty?: boolean;
  }) => {
    return (
      <SheetSectionContainer>
        <SheetSectionHeader
          icon={HammerIcon}
          isEmpty={isEmpty}
          title="Skills"
        />
        {children}
      </SheetSectionContainer>
    );
  };

  if (!filteredSkills.length) {
    return (
      <SkillsSheetSectionContainerAndHeader isEmpty>
        <SheetSectionEmptyText text="This candidate hasn't added any skills yet." />
      </SkillsSheetSectionContainerAndHeader>
    );
  }

  return (
    <SkillsSheetSectionContainerAndHeader>
      <SheetCollapsibleIndustryOrSkillList
        industriesOrSkills={filteredSkills}
      />
    </SkillsSheetSectionContainerAndHeader>
  );
};
